import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import { Site } from '../../../common/constants/siteList'
import { IRootState } from '../../../common/reducers'
import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { hasFeature } from '../../../common/utils/features'
import makeSearchLink from '../../../common/utils/location/makeSearchLink'
import { makeLink } from '../../../common/utils/urlHelper'

interface IOwnProps {
  location: any
}

interface IStateProps {
  currentSite: Site
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { common: { currentSite }, router: { location }, experiments } = state

  const newRoutesEnabled = hasFeature(
    'routes:new',
    currentSite,
    location,
    experiments
  )

  return {
    currentSite,
    makeSearchLink: newRoutesEnabled ? makeSearchLink : makeLink
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
) => {
  return {}
}

export type Props = IOwnProps & IStateProps

const createNotFoundContainer = (component: React.ComponentType<Props>) => {
  return connect<IStateProps, {}, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createNotFoundContainer
